export default {
    namespaced: true,
    state: {
        projects: [], // {id, mapSize, floorplans: [{id, size {1 | 2 | 3}}]}
    },
    getters: {
        getById(state) {
            return (id) => {
                if (state.projects) {
                    return state.projects.find((p) => p.id == id)
                }

                return undefined
            }
        },
    },
    actions: {
        addProject(ctx, obj) {
            ctx.commit('ADD', obj)
        },
        addFloorplan(ctx, obj) {
            ctx.commit('ADD_FLOORPLAN', obj)
        },
        removeProject(ctx, obj) {
            ctx.commit('REMOVE', obj)
        },
        reset(ctx) {
            ctx.commit('RESET')
        },
    },
    mutations: {
        ADD(state, obj) {
            let index = state.projects.findIndex((p) => p.id == obj.id)

            if (index != -1) {
                state.projects[index].mapSize = obj.mapSize
            } else {
                state.projects.push(obj)
            }
        },
        ADD_FLOORPLAN(state, obj) {
            let index = state.projects.findIndex((p) => p.id == obj.project_id)

            if (index != -1) {
                let fIndex = state.projects[index].floorplans.findIndex((f) => f.id == obj.id)

                if (fIndex != -1) {
                    state.projects[index].floorplans[fIndex].size = obj.size
                } else {
                    state.projects[index].floorplans.push({ id: obj.id, size: obj.size })
                }
            } else {
                state.projects.push({ id: obj.project_id, mapSize: 2, floorplans: [obj] })
            }
        },
        REMOVE(state, obj) {
            let index = state.projects.findIndex((p) => p.id == obj.id)

            if (index != -1) {
                state.projects.splice(index, 1)
            }
        },
        RESET(state) {
            state.projects = []
        },
    },
}
